import viewAllIcon from "../../../assets/images/view_all.png";

const datas = [
  {
    title: "Docs Updates",
    desc: [
      "A deep look into SWITCH’s trust architecture — the protocol, the flow, the economics.",
    ],
  },
  {
    title: "From the Blog",
    desc: [
      "Stories and insights on how SWITCH is redefining trust, commerce, and on-chain liquidity.",
    ],
  },
];

export default function Section8() {
  return (
    <section
      id="section8"
      className="relative z-10 w-full flex flex-col items-center justify-center mb-[80px] md:mb-[130px] lg:mb-[150px] text-white"
    >
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-8">
          {datas.map((data, index) => (
            <div key={index} className="flex flex-col">
              <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-4 gap-4 md:gap-0">
                <h3 className="text-[50px] font-normal text-white tracking-tight">
                  {data.title}
                </h3>
                <button className="px-4 py-2 border border-white rounded-full text-white uppercase tracking-wide hover:bg-white hover:text-black transition-all duration-300 flex items-center gap-2 w-fit">
                  <span className="text-[14px]">VIEW ALL</span>
                  <img
                    src={viewAllIcon}
                    alt="arrow"
                    className="object-contain"
                  />
                </button>
              </div>
              <div className="border-t border-white mb-4"></div>
              <div className="flex flex-col">
                {data.desc.map((item, itemIndex) => (
                  <div key={itemIndex} className="text-white text-[18px]">
                    {item}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
